import styled from "styled-components";
import { ingress, extendedSystemStyles } from "@mixins";
var styledSystemKeys = ["space", "layout", "color", "typography"];
export default styled.p.withConfig({
  displayName: "Ingress",
  componentId: "sc-68kzfc-0"
})(["", " ", ""], function (_ref) {
  var theme = _ref.theme,
    inverted = _ref.inverted;
  return "\n    ".concat(ingress(theme), "\n    color: ").concat(!inverted ? theme.colors.G4 : theme.colors.G1, ";\n    margin: 10px 0;");
}, extendedSystemStyles(styledSystemKeys));